'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _timePicker = require('./time-picker');

var _timePicker2 = _interopRequireDefault(_timePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _timePicker2.default;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/lib/time-picker/index.js
 ** module id = 454
 ** module chunks = 0
 **/